<script setup lang="ts">
import { ROUTES } from '~/utils/constants'
import HeroSection from '~/components/Landing/HeroSection.vue'
import SocialProof from '~/components/Landing/SocialProof.vue'
import Stats from '~/components/Landing/Stats.vue'
import BentoGrid from '~/components/Landing/BentoGrid.vue'
import Decorations from '~/components/Landing/Decorations.vue'

definePageMeta({
  layout: 'default',
})

useSiteSeoMeta({
  title: 'Master French Naturally',
  description:
    'Join thousands of students mastering French through immersive lessons, native conversations, and personalized learning paths.',
})
</script>

<template>
  <div class="relative overflow-hidden bg-white dark:bg-gray-950 min-h-screen">
    <Decorations />

    <HeroSection />

    <SocialProof />

    <Stats />

    <BentoGrid />

    <!-- Footer CTA -->
    <section class="py-24 relative overflow-hidden">
      <UContainer class="relative z-10 text-center">
        <div
          class="max-w-2xl mx-auto bg-white/50 dark:bg-gray-900/50 backdrop-blur-xl border border-gray-200 dark:border-gray-800 rounded-3xl p-12 shadow-2xl"
        >
          <h2 class="text-4xl font-bold mb-6 font-display text-gray-900 dark:text-white">
            Ready to start fluent?
          </h2>
          <p class="text-gray-600 dark:text-gray-400 mb-8 max-w-lg mx-auto">
            Join thousands of students who have already mastered French with TCF Canada.
          </p>
          <UButton size="xl" :to="ROUTES.SIGNUP" icon="i-heroicons-arrow-right" trailing
            >Get Started for Free</UButton
          >
        </div>
      </UContainer>

      <!-- Bottom Gradients -->
      <div
        class="absolute bottom-0 left-1/4 w-[500px] h-[500px] bg-indigo-500/10 rounded-full blur-[100px] pointer-events-none"
      ></div>
    </section>
  </div>
</template>
